/**
 * Utility functions for calculating and formatting item counts for accordions
 */

/**
 * Calculates item count display for zone-based sections
 * @param {Array} items - Array of items to count
 * @param {string} jobId - Current job ID
 * @returns {string} Formatted count string like "(1)", "(2)", "(1 | 2)", or empty string
 */
export const getZoneItemCount = (items, jobId) => {
  if (!items || items.length === 0) return '';
  
  // Filter items for current job
  const jobItems = items.filter(item => String(item.ProjectID) === String(jobId));
  
  if (jobItems.length === 0) return '';
  
  // Get unique zones
  const zones = [...new Set(jobItems.map(item => item.Zone))].sort();
  
  if (zones.length === 0) return '';
  
  // Count items per zone
  const zoneCounts = zones.map(zone => {
    const count = jobItems.filter(item => item.Zone === zone).length;
    return { zone, count };
  });
  
  // Format display based on zones present
  if (zones.length === 1) {
    return ` (${zoneCounts[0].count})`;
  } else if (zones.length === 2) {
    return ` (${zoneCounts[0].count} | ${zoneCounts[1].count})`;
  }
  
  return '';
};

/**
 * Calculates item count for Ship Early Parent (no zones)
 * @param {Array} items - Array of ship early parent items
 * @param {string} jobId - Current job ID
 * @returns {string} Formatted count string like "(3)" or empty string
 */
export const getShipEarlyItemCount = (items, jobId) => {
  if (!items || items.length === 0) return '';
  
  // Filter items for current job
  const jobItems = items.filter(item => String(item.ProjectID) === String(jobId));
  
  if (jobItems.length === 0) return '';
  
  return ` (${jobItems.length})`;
};
